import React, { createContext, useContext, useState } from "react";
import { collapsedDrawerWidth, expandedDrawerWidth } from "./sidebarMenuStyles";

interface ShellLayoutContextType {
  isSidebarExpanded: boolean;
  sidebarWidth: number;
  toggleSidebar: () => void;
}

const ShellLayoutContext = createContext<ShellLayoutContextType | undefined>(undefined);

export function ShellLayoutProvider({ children }: { children: React.ReactNode }) {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const sidebarWidth = isSidebarExpanded ? expandedDrawerWidth : collapsedDrawerWidth;

  const toggleSidebar = () => {
    setIsSidebarExpanded((currentValue) => !currentValue);
  };

  return (
    <ShellLayoutContext.Provider value={{ isSidebarExpanded, sidebarWidth, toggleSidebar }}>
      {children}
    </ShellLayoutContext.Provider>
  );
}

export function useShellLayout() {
  const context = useContext(ShellLayoutContext);

  if (!context) {
    throw new Error("useShellLayout must be used within a ShellLayoutProvider");
  }

  return context;
}
